import { useState } from 'react';
import { doc, updateDoc, increment, addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../services/firebase';

const RAZORPAY_KEY = "rzp_test_Sws6Lgrb9JQzZX";

const PACKAGES = [
  { coins: 900, price: 50, label: 'Starter' },
  { coins: 4800, price: 250, label: 'Popular', popular: true },
  { coins: 10800, price: 500, label: 'Value' },
  { coins: 22000, price: 1000, label: 'Pro' },
  { coins: 48000, price: 2000, label: 'Champion' },
];

export default function WalletScreen({ coins, onBack, userId }) {
  const [bought, setBought] = useState(null);

  const openRazorpay = (pkg) => {
    const options = {
      key: RAZORPAY_KEY,
      amount: pkg.price * 100,
      currency: "INR",
      name: "MalluGermanTalk",
      description: pkg.coins + " Coins",
      handler: async function (response) {
        try {
          if (userId) {
            await updateDoc(doc(db, 'users', userId), {
              coins: increment(pkg.coins)
            });
            await addDoc(collection(db, 'transactions'), {
              userId,
              type: 'purchase',
              coins: pkg.coins,
              amount: pkg.price,
              razorpayPaymentId: response.razorpay_payment_id,
              createdAt: serverTimestamp()
            });
            console.log('Coins saved!');
          }
        } catch (e) {
          console.error('Error:', e.message);
        }
        setBought(pkg);
        setTimeout(() => setBought(null), 2000);
      },
      prefill: { name: "Customer" },
      theme: { color: "#6366f1" },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleBuy = (pkg) => {
    if (window.Razorpay) {
      openRazorpay(pkg);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => openRazorpay(pkg);
    document.body.appendChild(script);
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Back</button>
        <div style={styles.headerTitle}>Coin Wallet</div>
      </div>

      <div style={styles.balanceCard}>
        <div style={styles.balanceLabel}>CURRENT BALANCE</div>
        <div style={styles.balanceRow}>
          <span style={styles.coinIcon}>🪙</span>
          <span style={styles.balanceAmount}>{coins.toLocaleString()}</span>
        </div>
        <div style={styles.balanceEquiv}>
          ≈ {Math.floor(coins / 2 / 60)} minutes of practice
        </div>
      </div>

      <div style={styles.section}>COIN PACKAGES</div>

      <div style={styles.packageList}>
        {PACKAGES.map((pkg, i) => (
          <button
            key={i}
            style={{
              ...styles.packageCard,
              ...(pkg.popular ? styles.packagePopular : {})
            }}
            onClick={() => handleBuy(pkg)}
          >
            {pkg.popular && (
              <div style={styles.popularBadge}>POPULAR</div>
            )}
            <div style={styles.packageLeft}>
              <span style={styles.packageEmoji}>🪙</span>
              <div>
                <div style={styles.packageCoins}>
                  {pkg.coins.toLocaleString()} Coins
                </div>
                <div style={styles.packageLabel}>{pkg.label} pack</div>
              </div>
            </div>
            <div style={styles.priceTag}>₹{pkg.price}</div>
          </button>
        ))}
      </div>

      {bought && (
        <div style={styles.successMsg}>
          ✅ {bought.coins.toLocaleString()} coins added!
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#0f0f1a',
    minHeight: '100vh',
    fontFamily: 'sans-serif',
  },
  header: {
    padding: '20px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    borderBottom: '1px solid #ffffff10',
  },
  backBtn: {
    backgroundColor: '#ffffff10',
    border: 'none',
    borderRadius: '10px',
    padding: '8px 14px',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '14px',
  },
  headerTitle: {
    color: '#ffffff',
    fontWeight: '800',
    fontSize: '18px',
  },
  balanceCard: {
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    margin: '16px',
    borderRadius: '20px',
    padding: '24px',
    textAlign: 'center',
  },
  balanceLabel: {
    color: '#ffffff80',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '2px',
  },
  balanceRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    margin: '8px 0',
  },
  coinIcon: { fontSize: '32px' },
  balanceAmount: {
    color: '#ffffff',
    fontSize: '40px',
    fontWeight: '900',
  },
  balanceEquiv: {
    color: '#ffffff60',
    fontSize: '12px',
  },
  section: {
    color: '#ffffff50',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '2px',
    padding: '0 16px 8px',
  },
  packageList: {
    padding: '0 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    maxWidth: '600px',
    margin: '0 auto',
  },
  packageCard: {
    backgroundColor: '#1e1e30',
    border: '1px solid #ffffff08',
    borderRadius: '16px',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    textAlign: 'left',
  },
  packagePopular: {
    border: '1px solid #6366f1',
    backgroundColor: '#1e1e35',
  },
  popularBadge: {
    position: 'absolute',
    top: '6px',
    right: '80px',
    backgroundColor: '#6366f1',
    borderRadius: '6px',
    padding: '2px 8px',
    fontSize: '9px',
    color: '#ffffff',
    fontWeight: '800',
  },
  packageLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  packageEmoji: { fontSize: '28px' },
  packageCoins: {
    color: '#ffffff',
    fontWeight: '800',
    fontSize: '16px',
  },
  packageLabel: {
    color: '#ffffff50',
    fontSize: '11px',
  },
  priceTag: {
    backgroundColor: '#f97316',
    borderRadius: '12px',
    padding: '8px 14px',
    color: '#ffffff',
    fontWeight: '900',
    fontSize: '16px',
  },
  successMsg: {
    position: 'fixed',
    bottom: '30px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#22c55e',
    color: '#ffffff',
    padding: '14px 28px',
    borderRadius: '14px',
    fontWeight: '800',
    fontSize: '15px',
  },
};